import React from 'react';

import styled from 'styled-components';
import { CreateNewCTA } from './CreateNewCTA';
import { JobPageCTA } from './JobPageCTA';

/*
 * bynder-platform/bynder/views/navigation/header.cfm: 379
 */

export function CTAWorkflow() {
	return (
		<>
			<JobPageCTA />
			<ul className="cta-main-container" id="uploadContainer">
				<CtaWrapper>
					<CreateNewCTA />
				</CtaWrapper>
			</ul>
		</>
	);
}

const CtaWrapper = styled.li`
	.action-btn {
		display: flex;
	}
`;
